import React from "react"
import { connect } from "react-redux"
import S from "./CartSummary.module.scss"

const CartSummary = props => {
  const subtotal =
    Math.floor(
      props.cart
        .map(product => {
          return product.price * product.quantity
        })
        .reduce((a, b) => a + b, 0)
        .toFixed(2) * 100
    ) / 100
  if (props.cart.length === 0) {
    return <div></div>
  }

  return (
    <article className={S.summary}>
      <div className={S.title}>
        <div>SUMMARY</div>
      </div>
      <div className={S.summaryitem}>
        <div>SUBTOTAL</div>
        <div>£{subtotal}</div>
      </div>
      <div className={S.summaryitem}>
        <div>
          VAT <small>(Included in Price)</small>
        </div>
        <div>£{Math.floor((subtotal / 100) * 20 * 100) / 100}</div>
      </div>
      <div className={S.summaryitem}>
        <div>
          DELIVERY <small>(Free To The UK)</small>
        </div>
        <div>£0.00</div>
      </div>
      <div className={S.summaryitem}>
        <div>TOTAL</div>
        <div>£{subtotal}</div>
      </div>

      <div className={S.snippestmessage}>
        **Shipping Only To The United Kingdom At This Time
      </div>
    </article>
  )
}

const mapStateToProps = state => {
  return {
    cart: state.shoppingCart.products,
  }
}

export default connect(mapStateToProps)(CartSummary)
